module.exports = __webpack_public_path__ + "img/Robert L Mc Collum.3e2cae06.jpg";